import {Routes, RouterModule} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {InicioComponent} from './components/inicio/inicio.component';

import {CreateCategoriaComponent} from './components/admin/categoria/create-categoria/create-categoria.component';
import {IndexCategoriaComponent} from './components/admin/categoria/index-categoria/index-categoria.component';


import {EditCategoriaComponent} from './components/admin/categoria/edit-categoria/edit-categoria.component';

import {CreateProductoComponent} from './components/admin/producto/create-producto/create-producto.component';
import {CreateMarcaComponent} from './components/admin/marca/create-marca/create-marca.component';
import {IndexMarcaComponent} from './components/admin/marca/index-marca/index-marca.component';
import {EditMarcaComponent} from './components/admin/marca/edit-marca/edit-marca.component';
import {PortadaComponent} from './components/admin/config/general/portada.component';
import {IndexProductoComponent} from './components/admin/producto/index-producto/index-producto.component';
import {EditProductoComponent} from './components/admin/producto/edit-producto/edit-producto.component';
import {GaleriaProductoComponent} from './components/admin/producto/galeria-producto/galeria-producto.component';
import {SelectorProductoComponent} from './components/admin/producto/selector-producto/selector-producto.component';
import {ColorProductoComponent} from './components/admin/producto/color-producto/color-producto.component';
import {PapeleraProductoComponent} from './components/admin/producto/papelera-producto/papelera-producto.component';
import {ProductosComponent} from './components/productos/productos.component';
import {ShowProductoComponent} from './components/show-producto/show-producto.component';
import {CollectionsComponent} from './components/collections/collections.component';
import {AboutComponent} from './components/about/about.component';
import {TrabajosocialComponent} from './components/trabajosocial/trabajosocial.component';
import {PromosComponent} from './components/promos/promos.component';
import {EspecialidadesComponent} from './components/especialidades/especialidades.component';
import {PlanesComponent} from './components/planes/planes.component';
import {ConveniosComponent} from './components/convenios/convenios.component';
import {CitaComponent} from './components/cita/cita.component';
import {FAQComponent} from './components/faq/faq.component';
import {ArticlesComponent} from './components/articles/articles.component';
import {ShowArticleComponent} from './components/show-article/show-article.component';
import {CarritoService} from './services/carrito.service';
import {CarritoComponent} from './components/carrito/carrito.component';
import {PerfilComponent} from './components/cuenta/perfil/perfil.component';
import {DireccionesComponent} from './components/cuenta/direcciones/direcciones.component';
import {CuponComponent} from './components/admin/cupon/cupon.component';
import {PostalComponent} from './components/admin/postal/postal.component';
import {IndexOrdenesComponent} from './components/cuenta/ordenes/index-ordenes/index-ordenes.component';
import {TrackOrdenComponent} from './components/cuenta/ordenes/track-orden/track-orden.component';
import {DetalleOrdenComponent} from './components/cuenta/ordenes/detalle-orden/detalle-orden.component';
import {IndexTicketComponent} from './components/cuenta/ordenes/index-ticket/index-ticket.component';
import {AdminVentasComponent} from './components/admin/ventas/admin-ventas/admin-ventas.component';
import {AdminDetalleventasComponent} from './components/admin/ventas/admin-detalleventas/admin-detalleventas.component';
import {ContactoComponent} from './components/contacto/contacto.component';
import {ErrorComponent} from './components/error/error.component';
import {ContactoAdminComponent} from './components/admin/contacto-admin/contacto-admin.component';
import {DashboardComponent} from './components/admin/dashboard/dashboard.component';
import {IndexIngresoComponent} from './components/admin/ingreso/index-ingreso/index-ingreso.component';
import {CreateIngresoComponent} from './components/admin/ingreso/create-ingreso/create-ingreso.component';
import {DetalleIngresoComponent} from './components/admin/ingreso/detalle-ingreso/detalle-ingreso.component';
import {RecoveryComponent} from './components/recovery/recovery.component';
import {PreguntaComponent} from './components/admin/pregunta/pregunta.component';
import {locationComponent} from "./components/admin/hitos/location.component";
import {PromocionComponent} from "./components/admin/promocion/promocion.component";
import {GeneralinfoComponent} from "./components/admin/generalinfo/generalinfo.component";
import {EspedashboardComponent} from "./components/admin/espedashboard/espedashboard.component";
import { MsalGuard } from "@azure/msal-angular";
import { IndexArticleComponent } from './components/admin/article/index-article/index-article.component';
import { CreateArticleComponent } from './components/admin/article/create-article/create-article.component';
import { EditArticleComponent } from './components/admin/article/edit-article/edit-article.component';

import {PopUpFormComponent} from './components/admin/pop-up-form/pop-up-form.component';
import {PoliticasComponent} from './components/politicas/politicas.component';




const appRoute: Routes = [
  {path: '', component: InicioComponent},
  {path: 'home/:subplace', component: InicioComponent},
  {path: 'restablecer-contraseña', component: RecoveryComponent},

  {path: 'promo', component: ContactoComponent},
  {path: 'dashboard', component: DashboardComponent, canActivate: [MsalGuard]},
  {path: 'anteojos', component: ProductosComponent, canActivate: [MsalGuard]},
  // {path: 'collections', component: CollectionsComponent},
  {path: 'preguntasfrecuentes', component: FAQComponent},
  {path: 'blog', component: ArticlesComponent},
  {path: 'blog/:slug', component: ShowArticleComponent},
  {path: 'sobrenosotros', component: AboutComponent},
  {path: 'sobreasembis', component: AboutComponent},
  {path: 'trabajosocial', component: TrabajosocialComponent},
  {path: 'promociones', component: PromosComponent},
  {path: 'convenios', component: ConveniosComponent},
  {path: 'citas', component: CitaComponent},
  {path: 'especialidades', component: EspecialidadesComponent},
  {path: 'planesdesalud', component: PlanesComponent},
  {path: 'producto/:slug', component: ShowProductoComponent},
  {path: 'anteojos/search/:filter', component: ProductosComponent},
  {path: 'anteojos/:categoria', component: ProductosComponent},
  // {path: 'anteojos/:categoria/subcategoria/:subcategoria', component: ProductosComponent},

  {path: 'politicasdeprivacidad', component: PoliticasComponent},

  {path: 'cuenta/shop-cart', component: CarritoComponent},
  {path: 'cuenta/perfil', component: PerfilComponent},
  {path: 'cuenta/direcciones', component: DireccionesComponent},
  {path: 'cuenta/ordenes', component: IndexOrdenesComponent},
  {path: 'cuenta/ordenes/tracking/:id', component: TrackOrdenComponent},
  {path: 'cuenta/ordenes/detalles/:id', component: DetalleOrdenComponent},

  {
    path: 'admin', canActivate: [MsalGuard] , children: [
      {path: 'categorias', component: IndexCategoriaComponent},
      {path: 'categoria/registro', component: CreateCategoriaComponent},
      {path: 'categoria/:id', component: EditCategoriaComponent},


      {path: 'productos', component: IndexProductoComponent},
      {path: 'producto/papelera', component: PapeleraProductoComponent},
      {path: 'producto/registro', component: CreateProductoComponent},
      {path: 'producto/:id', component: EditProductoComponent},
      {path: 'producto/:id/galeria', component: GaleriaProductoComponent},
      {path: 'producto/:id/selector', component: SelectorProductoComponent},
      {path: 'portada', component: PortadaComponent},
      {path: 'location', component: locationComponent},
      {path: 'preguntas', component: PreguntaComponent},
      {path: 'location', component: locationComponent},
      {path: 'promocion-admin', component: PromocionComponent},
      {path: 'infogeneral', component: GeneralinfoComponent},
      {path: 'especialidadesadmin', component: EspedashboardComponent},

      {path: 'popup', component: PopUpFormComponent},

      {path: 'producto/:id/color', component: ColorProductoComponent},
      // {path: 'cupones', component: CuponComponent},
      {path: 'medios-postales', component: PostalComponent},

      {path: 'articles', component: IndexArticleComponent},
      {path: 'article/new', component: CreateArticleComponent},
      {path: 'article/:id', component: EditArticleComponent},
      {path: 'ventas/modulo', component: AdminVentasComponent},
      
      {path: 'venta/modulo/detalle/:id', component: AdminDetalleventasComponent},

      {path: 'mensajes', component: ContactoAdminComponent},

      {path: 'ingresos', component: IndexIngresoComponent},
      {path: 'ingresos/registro', component: CreateIngresoComponent},
      {path: 'ingresos/detalle/:id', component: DetalleIngresoComponent},
    ]
  },
  {path: '**', component: ErrorComponent},

  /*   { path: '**', redirectTo: '/'} */
];

export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoute, {});


